import { ReactNode } from 'react';

import { RelatedRecommendCarousels } from '../components/carousel/RelatedRecommendCarousels';
import { RecommendTabLayout } from '../components/RecommendTabLayout';
import { useRecommendTabService } from '../services/useRecommendTabService';

interface RecommendTabContainerProps {
  productId: string;
  children?: ReactNode;
}

export const RecommendTabContainer = ({ productId, children }: RecommendTabContainerProps) => {
  const { carouselsList, onImpressionProduct, onClickProduct, onSavedProduct, onClickViewMore } =
    useRecommendTabService(productId);

  if (!carouselsList.length && !children) return null;

  return (
    <RecommendTabLayout>
      {children}
      {!!carouselsList.length && (
        <RelatedRecommendCarousels
          lists={carouselsList}
          onImpressionProduct={onImpressionProduct}
          onClickProduct={onClickProduct}
          onSaveProduct={onSavedProduct}
          onClickMore={onClickViewMore}
        />
      )}
    </RecommendTabLayout>
  );
};
